export default __webpack_public_path__ + "static/media/scrabble-2048w.7f3cfcc8.webp";